import { render, staticRenderFns } from "./Setname.vue?vue&type=template&id=e35264f8&scoped=true&"
import script from "./Setname.vue?vue&type=script&lang=js&"
export * from "./Setname.vue?vue&type=script&lang=js&"
import style0 from "./Setname.vue?vue&type=style&index=0&id=e35264f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35264f8",
  null
  
)

export default component.exports